import { Spinner } from 'flowbite-react';
import React from 'react';
import { BiChevronRight } from 'react-icons/bi';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { startMyChallenge } from 'src/apis/prepPlan';
import { useToast } from 'src/context/ToastProvider';
import { UIMyChallenges } from 'types';
import NewCreatingPositionLoader from '../position/NewCreatingPositionLoader';

interface Props {
	challenge: UIMyChallenges;
	isHorizontalLayout?: boolean;
}

const ChallengeCardCTA = ({ challenge, isHorizontalLayout }: Props) => {
	const navigate = useNavigate();
	const isChallengeStarted = challenge.prepPlan;
	const toast = useToast();
	const startMyChallengeFn = useMutation(['startMyChallenge'], startMyChallenge, {
		onSuccess(data) {
			if (data.challenge?.prepPlan) {
				toast({
					title: 'Challenge started',
					type: 'success',
				});
				navigate(`/challenges/${data.challenge?.prepPlan?._id}`);
			} else {
				toast({
					title: 'Some error occured. Please refresh',
					type: 'error',
				});
			}
		},
		onError() {
			toast({
				title: 'Some error occured. Please refresh',
				type: 'error',
			});
		},
	});
	return (
		<div
			className={
				isHorizontalLayout
					? `mt-[6px] rounded-bl-[8px] rounded-br-[8px]`
					: `bg-[#FAFAFC] dark:bg-[#18222D] border-t border-[#E2E8F0] dark:border-none  px-[16px] py-[12px] rounded-bl-[8px] rounded-br-[8px] flex justify-between`
			}
		>
			{isChallengeStarted ? (
				<div>
					<p className="text-[16px] font-[500] leading-[24px] font-inter dark:text-[#F2F2F5]">
						{challenge.progress}% <span className="text-[10px] font-[400] leading-[10px]">progress</span>
					</p>
				</div>
			) : (
				<div className="flex items-center gap-[8px]">
					<p className="text-[16px] font-[500] leading-[24px] font-inter  dark:text-[#F2F2F5]">
						{challenge.days}{' '}
						<span className="text-[10px] font-[400] leading-[10px] text-[#8F90A6] dark:text-[#E5FFFF]">days</span>
					</p>
					{/* create a dot */}
					<div className="w-[4px] h-[4px] bg-gray-400 dark:bg-[#F2F2F5] rounded-full mx-[4px]"></div>
					<p className="text-[16px] font-[500] leading-[24px] font-inter dark:text-[#F2F2F5]">
						{challenge.totalProblems}{' '}
						<span className="text-[10px] font-[400] leading-[10px] text-[#8F90A6] dark:text-[#E5FFFF]">problems</span>
					</p>
				</div>
			)}

			<div className={'flex items-center ' + (isHorizontalLayout ? `mt-[4px]` : ``)}>
				{startMyChallengeFn.isLoading ? (
					<Spinner />
					// <NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="w-[40%] mx-auto " />
				) : 
				isChallengeStarted ? (
					<button
						onClick={() => {
							navigate(`/challenges/${challenge?.prepPlan?._id}`);
						}}
						className="flex items-center text-[12px] font-[600] leading-[18px] font-inter text-[#7777E7] dark:text-[#6698FA]"
					>
						Continue
						<BiChevronRight size={'16px'} className="ml-[4px] text-[#7777E7]" />
					</button>
				) : (
					<button
						onClick={() => {
							startMyChallengeFn.mutate(challenge.template._id);
						}}
						className=" flex items-center text-[12px] font-[600] leading-[18px] font-inter text-[#7777E7] dark:text-[#6698FA]"
					>
						Start
						<BiChevronRight size={'16px'} className="ml-[4px] text-[#7777E7]" />
					</button>
				)}
			</div>
		</div>
	);
};

export default ChallengeCardCTA;
